import {
	GET_UPLOAD_FILE_STATUS_FAILED,
	GET_UPLOAD_FILE_STATUS_REQUEST,
	GET_UPLOAD_FILE_STATUS_RESET,
	GET_UPLOAD_FILE_STATUS_SUCCESS,
	GET_UPLOAD_SUPPORTED_FILE_FORMAT_FAILED,
	GET_UPLOAD_SUPPORTED_FILE_FORMAT_REQUEST,
	GET_UPLOAD_SUPPORTED_FILE_FORMAT_RESET,
	GET_UPLOAD_SUPPORTED_FILE_FORMAT_SUCCESS,
	OPEN_UPLOAD,
	POST_UPLOAD_FILE_FAILED,
	POST_UPLOAD_FILE_REQUEST,
	POST_UPLOAD_FILE_RESET,
	POST_UPLOAD_FILE_SUCCESS,
} from "../types"

export const setUploadOpen = (data) => ({
	type: OPEN_UPLOAD,
	payload: data,
})

//get supported formats
export const getUploadFileFormatRequest = (data) => ({
	type: GET_UPLOAD_SUPPORTED_FILE_FORMAT_REQUEST,
	payload: data,
})

export const getUploadFileFormatSuccess = (data) => ({
	type: GET_UPLOAD_SUPPORTED_FILE_FORMAT_SUCCESS,
	payload: data,
})

export const getUploadFileFormatFailed = (data) => ({
	type: GET_UPLOAD_SUPPORTED_FILE_FORMAT_FAILED,
	payload: data,
})

export const getUploadFileFormatReset = () => ({
	type: GET_UPLOAD_SUPPORTED_FILE_FORMAT_RESET,
})

//Start upload
export const uploadFileRequest = (data) => ({
	type: POST_UPLOAD_FILE_REQUEST,
	payload: data,
})

export const uploadFileSuccess = (data) => ({
	type: POST_UPLOAD_FILE_SUCCESS,
	payload: data,
})

export const uploadFileFailed = (data) => ({
	type: POST_UPLOAD_FILE_FAILED,
	payload: data,
})

export const uploadFileReset = () => ({
	type: POST_UPLOAD_FILE_RESET,
})

//get upload status
export const getUploadFileStatusRequest = (data) => ({
	type: GET_UPLOAD_FILE_STATUS_REQUEST,
	payload: data,
})

export const getUploadFileStatusSuccess = (data) => ({
	type: GET_UPLOAD_FILE_STATUS_SUCCESS,
	payload: data,
})

export const getUploadFileStatusFailed = (data) => ({
	type: GET_UPLOAD_FILE_STATUS_FAILED,
	payload: data,
})

export const getUploadFileStatusReset = () => ({
	type: GET_UPLOAD_FILE_STATUS_RESET,
})
